export function signInRequest(email, password) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: { email, password },
  };
}

export function signInSuccess(token, user) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, user },
  };
}

export function signUpRequest(organization, name, email, emailConfirm, password, passwordConfirm, birth) {
  return {
    type: '@auth/SIGN_UP_REQUEST',
    payload: { organization, name, email, emailConfirm, password, passwordConfirm, birth },
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}

export function recoveryRequest(email, password) {
  return {
    type: '@auth/RECOVERY_REQUEST',
    payload: { email, password },
  };
}

export function recoveryUpdateRequest(token, code, password, passwordConfirm) {
  return {
    type: '@auth/RECOVERY_UPDATE_REQUEST',
    payload: { token, code, password, passwordConfirm },
  };
}

export function recoverySuccess() {
  return {
    type: '@auth/RECOVERY_SUCCESS',
  };
}

export function recoveryFailure() {
  return {
    type: '@auth/RECOVERY_FAILURE',
  };
}
